module.exports = __webpack_public_path__ + "static/media/neural_solutions.913eb7ba.png";